(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["joud-countdown"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('joud-countdown')) return;
  const PERIOD = 3 * 24 * 60 * 60 * 1000;
  const remaining = (now, anchor) => PERIOD - (((now - anchor) % PERIOD + PERIOD) % PERIOD);
  class JoudCountdown extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.copyButton = this.querySelector('[data-copy]');
      this.copyStatus = this.querySelector('[data-copy-status]');
      this.copyLabel = this.querySelector('[data-copy-label]');
      this.onCopy = async () => {
        const code = this.copyButton.dataset.code;
        try {
          if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(code);
          if (!this.isConnected) return;
          this.copyLabel.textContent = 'تم النسخ ✓';
          this.copyStatus.textContent = 'تم نسخ كود الخصم';
          this.copyStatus.className = 'jc-sr';
          clearTimeout(this.copyReset);
          this.copyReset = setTimeout(() => {
            this.copyLabel.textContent = 'نسخ كود الخصم';
            this.copyStatus.textContent = '';
          }, 2500);
        } catch (_) {
          if (!this.isConnected) return;
          this.copyStatus.className = 'jc-copy-status';
          this.copyStatus.textContent = 'تعذّر النسخ. انسخ الكود يدويًا: ' + code;
        }
      };
      if (this.copyButton) this.copyButton.addEventListener('click', this.onCopy);
      this.anchor = Date.parse(this.dataset.anchor);
      this.digits = [...this.querySelectorAll('[data-digit]')];
      this.clock = this.querySelector('[data-clock]');
      this.summary = this.querySelector('[data-summary]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!Number.isFinite(this.anchor)) {
        this.clock.hidden = true;
        this.summary.textContent = 'العدّاد غير متاح حاليًا.';
        return;
      }
      this.onVisibility = () => {
        clearTimeout(this.timer);
        if (!document.hidden) this.tick();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.tick();
    }
    tick() {
      const now = Date.now();
      if (now < this.anchor) {
        this.clock.hidden = true;
        this.summary.textContent = 'يبدأ العرض قريبًا.';
      } else {
        this.clock.hidden = false;
        const total = Math.ceil(remaining(now, this.anchor) / 1000);
        const values = [Math.floor(total / 86400), Math.floor(total / 3600) % 24, Math.floor(total / 60) % 60, total % 60];
        this.digits.forEach((el, i) => {
          const next = String(values[i]).padStart(2, '0');
          if (el.textContent === next) return;
          el.textContent = next;
          if (!this.reduced.matches) {
            el.classList.remove('jc-tick');
            void el.offsetWidth;
            el.classList.add('jc-tick');
          }
        });
        // Readable on demand; never announce every second to screen readers.
        this.summary.textContent = `يتجدد العرض بعد ${values[0]} يوم و${values[1]} ساعة و${values[2]} دقيقة.`;
      }
      if (!document.hidden) this.timer = setTimeout(() => this.tick(), 1000 - Date.now() % 1000 + 15);
    }
    stop() {
      clearTimeout(this.timer);
      clearTimeout(this.copyReset);
      if (this.copyButton && this.onCopy) this.copyButton.removeEventListener('click', this.onCopy);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() { this.stop(); }
  }
  customElements.define('joud-countdown', JoudCountdown);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joud-mersal-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('joud-mersal-popup')) {
  customElements.define('joud-mersal-popup', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.key = 'jm-popup:' + (this.dataset.campaign || 'default');
      this.previousFocus = null;

      this.querySelectorAll('[data-jm-close]').forEach(control => control.addEventListener('click', event => { event.preventDefault(); this.close(); }, {signal}));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog || this.dataset.outside !== 'true') return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close();
      }, {signal});
      this.dialog.addEventListener('close', () => {
        if (this.scrollLock) { document.documentElement.style.overflow = this.oldOverflow; this.scrollLock = false; }
        if (this.previousFocus?.isConnected) this.previousFocus.focus({preventScroll:true});
      }, {signal});
      this.querySelector('.jm-copy').addEventListener('click', () => this.copy(), {signal});
      this.closest('.shopify-section')?.addEventListener('shopify:section:select', () => { if (this.dataset.enabled === 'true') this.open(); }, {signal});
      if (this.dataset.enabled !== 'true') return;
      if (window.Shopify?.designMode) { if (this.dataset.preview === 'true') this.timer = setTimeout(() => this.open(), 150); return; }
      if (!this.seen()) this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
    }
    seen() {
      try {
        if (this.dataset.frequency === 'always') return false;
        if (this.dataset.frequency === 'days') return Date.now() - Number(localStorage.getItem(this.key) || 0) < Number(this.dataset.days) * 86400000;
        return sessionStorage.getItem(this.key) === 'seen';
      } catch { return false; }
    }
    remember() {
      if (window.Shopify?.designMode) return;
      try {
        if (this.dataset.frequency === 'days') localStorage.setItem(this.key, String(Date.now()));
        else if (this.dataset.frequency === 'session') sessionStorage.setItem(this.key, 'seen');
      } catch {}
    }
    open() {
      if (!this.isConnected || this.dialog.open) return;
      if (document.querySelector('dialog[open]')) { this.timer = setTimeout(() => this.open(), 1000); return; }
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      this.oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.scrollLock = true;
      this.remember();
    }
    close() { this.dialog.close(); }
    async copy() {
      const code = this.querySelector('.jm-code');
      const status = this.querySelector('.jm-status');
      try {
        await navigator.clipboard.writeText(code.textContent.trim());
        status.textContent = this.dataset.copied;
      } catch {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(code); selection.removeAllRanges(); selection.addRange(range);
        status.textContent = this.dataset.copyError;
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.scrollLock) document.documentElement.style.overflow = this.oldOverflow;
      this.dialog?.close();
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joud-offer-popup"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('joud-popup-clock')) return;
  const PERIOD = 3 * 24 * 60 * 60 * 1000;
  const remaining = (now, anchor) => PERIOD - (((now - anchor) % PERIOD + PERIOD) % PERIOD);
  class JoudPopupClock extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        this.onReady = () => this.initialize();
        document.addEventListener('DOMContentLoaded', this.onReady, {once:true});
        return;
      }
      this.initialize();
    }
    initialize() {
      if (!this.isConnected) return;
      this.stop();
      this.copyButton = this.querySelector('[data-copy]');
      this.copyStatus = this.querySelector('[data-copy-status]');
      this.copyLabel = this.querySelector('[data-copy-label]');
      this.onCopy = async () => {
        const code = this.copyButton.dataset.code;
        try {
          if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(code);
          if (!this.isConnected) return;
          this.copyLabel.textContent = 'تم النسخ ✓';
          this.copyStatus.textContent = 'تم نسخ كود الخصم';
          this.copyStatus.className = 'jc-sr';
          clearTimeout(this.copyReset);
          this.copyReset = setTimeout(() => {
            this.copyLabel.textContent = 'نسخ كود الخصم';
            this.copyStatus.textContent = '';
          }, 2500);
        } catch (_) {
          if (!this.isConnected) return;
          this.copyStatus.className = 'jc-copy-status';
          this.copyStatus.textContent = 'تعذّر النسخ. انسخ الكود يدويًا: ' + code;
        }
      };
      if (this.copyButton) this.copyButton.addEventListener('click', this.onCopy);
      this.anchor = Date.parse(this.dataset.anchor);
      this.digits = [...this.querySelectorAll('[data-digit]')];
      this.clock = this.querySelector('[data-clock]');
      this.summary = this.querySelector('[data-summary]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!Number.isFinite(this.anchor)) {
        this.clock.hidden = true;
        this.summary.textContent = 'العدّاد غير متاح حاليًا.';
        return;
      }
      this.onVisibility = () => {
        clearTimeout(this.timer);
        if (!document.hidden) this.tick();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.tick();
    }
    tick() {
      const now = Date.now();
      if (now < this.anchor) {
        this.clock.hidden = true;
        this.summary.textContent = 'يبدأ العرض قريبًا.';
      } else {
        this.clock.hidden = false;
        const total = Math.ceil(remaining(now, this.anchor) / 1000);
        const values = [Math.floor(total / 86400), Math.floor(total / 3600) % 24, Math.floor(total / 60) % 60, total % 60];
        this.digits.forEach((el, i) => {
          const next = String(values[i]).padStart(2, '0');
          if (el.textContent === next) return;
          el.textContent = next;
          if (!this.reduced.matches) {
            el.classList.remove('jc-tick');
            void el.offsetWidth;
            el.classList.add('jc-tick');
          }
        });
        // Readable on demand; never announce every second to screen readers.
        this.summary.textContent = `يتجدد العرض بعد ${values[0]} يوم و${values[1]} ساعة و${values[2]} دقيقة.`;
      }
      if (!document.hidden) this.timer = setTimeout(() => this.tick(), 1000 - Date.now() % 1000 + 15);
    }
    stop() {
      if (this.onReady) document.removeEventListener('DOMContentLoaded', this.onReady);
      clearTimeout(this.timer);
      clearTimeout(this.copyReset);
      if (this.copyButton && this.onCopy) this.copyButton.removeEventListener('click', this.onCopy);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() { this.stop(); }
  }
  customElements.define('joud-popup-clock', JoudPopupClock);
})();

(() => {
 if (customElements.get('joud-offer-overlay')) return;
 class JoudOfferOverlay extends HTMLElement {
  connectedCallback() {
   if (document.readyState === 'loading') {
    this.ready = () => this.initialize();
    document.addEventListener('DOMContentLoaded', this.ready, {once:true});
   } else this.initialize();
  }
  initialize() {
   if (!this.isConnected) return;
   this.cleanup();
   this.dialog = this.querySelector('dialog');
   if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
   this.events = new AbortController();
   const listen = (target, type, fn, options={}) => target.addEventListener(type,fn,{...options,signal:this.events.signal});
   this.editor = !!(window.Shopify && window.Shopify.designMode);
   this.key = 'joud-popup-section-visit-v1-' + this.dataset.sectionId;
   let saved;
   try { saved = JSON.parse(sessionStorage.getItem(this.key)); } catch (_) {}
   const now = Date.now();
   this.visit = saved && Number.isFinite(saved.last) && now - saved.last < 1800000 ? saved : {last:now,shown:false};
   this.visit.last = now;
   if (!this.editor) this.save();
   this.querySelectorAll('[data-jp-close]').forEach(button=>listen(button,'click',()=>this.dialog.close()));
   listen(this.dialog,'click',event=>{ if(event.target === this.dialog) this.dialog.close(); });
   listen(this.dialog,'close',()=>this.restore());
   listen(document,'shopify:section:select',event=>{
    if (String(event.detail.sectionId) === this.dataset.sectionId) this.open();
   });
   listen(document,'shopify:section:deselect',event=>{
    if (String(event.detail.sectionId) === this.dataset.sectionId && this.dialog.open) this.dialog.close();
   });
   // Optional local-preview control; absent in the Shopify section.
   document.querySelectorAll('[data-jp-preview]').forEach(button=>listen(button,'click',()=>this.open()));
   if (this.editor) {
    if (this.dataset.preview === 'true') this.timer = setTimeout(()=>this.open(),100);
    return;
   }
   const touch = () => { if(Date.now()-this.visit.last > 10000) { this.visit.last=Date.now();this.save(); } };
   ['pointerdown','keydown','scroll'].forEach(type=>listen(window,type,touch,{passive:true}));
   listen(window,'pagehide',()=>{this.visit.last=Date.now();this.save();});
   if (this.dataset.frequency === 'page' || !this.visit.shown) {
    let attempts=0;
    const attempt=()=>{
     if(this.open() || ++attempts >= 8) return;
     this.timer=setTimeout(attempt,1500);
    };
    this.timer=setTimeout(attempt,Number(this.dataset.delay) || 0);
   }
  }
  save() { try { sessionStorage.setItem(this.key,JSON.stringify(this.visit)); } catch (_) {} }
  open() {
   if (!this.isConnected || !this.dialog || this.dialog.open || document.hidden || document.querySelector('dialog[open]')) return false;
   this.previousFocus=document.activeElement;
   this.previousOverflow=document.documentElement.style.overflow;
   this.previousPadding=document.documentElement.style.paddingRight;
   const scrollbar=window.innerWidth-document.documentElement.clientWidth;
   this.dialog.showModal();
   document.documentElement.style.overflow='hidden';
   if(scrollbar>0) document.documentElement.style.paddingRight=scrollbar+'px';
   this.openedHere=true;
   if (!this.editor) {this.visit.shown=true;this.visit.last=Date.now();this.save();}
   return true;
  }
  restore() {
   if(!this.openedHere) return;
   document.documentElement.style.overflow=this.previousOverflow;
   document.documentElement.style.paddingRight=this.previousPadding;
   this.openedHere=false;
   if(this.previousFocus && this.previousFocus.isConnected) this.previousFocus.focus({preventScroll:true});
  }
  cleanup() {
   clearTimeout(this.timer);
   if(this.ready) document.removeEventListener('DOMContentLoaded',this.ready);
   if(this.events) this.events.abort();
   if(this.dialog && this.dialog.open) this.dialog.close();
   this.restore();
  }
  disconnectedCallback() {this.cleanup();}
 }
 customElements.define('joud-offer-overlay',JoudOfferOverlay);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
